import React, { Fragment } from 'react';
import { Section } from '../../../../Components/Section/Section';
import InsightsCard from '../components/Card/InsightsCard';
import { useAiInsightsContext } from '../context/AiInsightsContext';
import {AiInsight} from '../context/AiInsightsApiTypesServices';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import {
	SkeletonSquare,
	SkeletonBar,
	SkeletonFlex,
	SkeletonBox,
	SkeletonRect
} from '../../../../Components/Skeleton/Skeleton';

import EmptyState from '../../../../Components/EmptyState';
import { Article } from '../../../../Components/Article/Article';
import AiInsightsFilters from './AiInsightsFilters';

export default function AiInsightListContainer() {

	const {
		aiInsights,
		error,
		isLoading,
		filteredFindings,
		chartType
	} = useAiInsightsContext();

	const i18nL = localStorage.getItem('i18nL') || 'en-EN';
	const langue = JSON.parse(i18nL).trim();
	const date = (aiInsights && aiInsights.length && aiInsights[0].date) ? aiInsights[0].date : null;
	const content = {
		'fr-FR' : 'Dernière mise à jour',
		'en-EN' : 'Last update'
	};

	const repeat = (jsx:React.ReactNode, nb:number) => {
		const result:React.ReactNode[] = [];
		for (let i = 0; i < nb; i++) {
			result.push(
				<Fragment key={i}>{jsx}</Fragment>
			);
		}
		return result;
	};

	const getLastUpdateDate = (date) => {
		const endOfDate = moment(date).endOf('day');
		const diff = moment().diff(endOfDate, 'hours');
		if (diff < 0) {
			return 'Today';
		}
		if (diff < 24) {
			return 'Yesterday';
		} 
		return endOfDate.fromNow();
	};

	return (
		<Section width={!isLoading && error ? 'm' : 's'}>
			<section className="section no_bottom_pad section_primary">
				<div className='flex'>
					<div className='flex_item_full'>
						<div className="h1">AI insights</div>
					</div>
					{!isLoading && !error && date && (
						<div className='flex_item_fix ml_20'>
							<p className="grey_2 s_14">
								<span className='fw_medium'>{content[langue.trim() || 'en-EN']}:</span>
								{' ' + getLastUpdateDate(date)}
							</p>
						</div>
					)}
				</div>
				<div className='mt_10 grey_2'>Instantly spot what matters: powered by AI, our tool scans millions of data points in real time to surface the most striking insights happening on your site right now — the ones you simply can't afford to miss.</div>
			</section>
			<section className="section">
				{!isLoading &&
					<AiInsightsFilters />
				}
				{isLoading && (
					<>
						{repeat(
							<Article innerSize='l'>
								<SkeletonFlex alignItems='flex-start'>
									<SkeletonSquare width='l' />
									<SkeletonBox>
										<SkeletonBar height="m" width="l" />
										<SkeletonBar height="m" width="s" />
										<SkeletonRect width={160} height={82} />
									</SkeletonBox>
								</SkeletonFlex>
							</Article>,
							3
						)}
					</>	)
				}
				{!isLoading && error && (
					<Article>
						<EmptyState
							title='AI insights'
							imageUrl='/Assets/empty_aiinsights.svg'
							textSize='xl'
							verticalSize='xl'
							text='No data yet, please contact an administrator for more information'
						/>
					</Article>
				)}
				{!isLoading && !error && Array.isArray(filteredFindings) && filteredFindings.length === 0 && (
					<Article>
						<EmptyState
							title="AI insights"
							imageUrl="/Assets/empty_aiinsights.svg"
							textSize="xl"
							verticalSize="xl"
							text="No result for this search please"
						/>
					</Article>
				)}
				{!isLoading && !error && Array.isArray(filteredFindings) && filteredFindings.length > 0 && (
					filteredFindings.map((insight: AiInsight) => (
						<InsightsCard
							key={uuidv4()}
							insight={insight}
							chartType={chartType}
						/>
					))
				)}
			</section>
		</Section>
	);
}
